import React from "react";
import { useTranslation } from "react-i18next";

import { useWorkspaceContext } from "@scenes/workspaceContext";
import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import { DataTypeFilter } from "./dataTypeFilter";
import styles from "./styles.scss";

function Filters({ filter, setFilter, reset }: Props) {
  const { t } = useTranslation();
  const ctx = useWorkspaceContext();
  const isInPlanzone = ctx.type === "planzone";
  const isInZone = ctx.type === "zone";

  return (
    <div className={styles.filters}>
      <p className={styles.label}>
        {t("projectPage.ganttPage.filters.seeTasksOf")} :
      </p>
      {isInPlanzone ? (
        <div className={styles.section}>
          <FilterMenu
            filter={filter}
            placeholder={t("projectPage.ganttPage.filters.zonesPlaceholder")}
            views={[
              "zones",
              "projects",
              "projectsTags",
              "projectPortfolios",
              "projectStatuses",
            ]}
            openedViews={["zones"]}
            setFilter={setFilter}
          />
        </div>
      ) : isInZone ? (
        <div className={styles.section}>
          <FilterMenu
            filter={filter}
            placeholder={t("projectPage.ganttPage.filters.zonePlaceholder")}
            views={[
              "projects",
              "projectsTags",
              "projectPortfolios",
              "projectStatuses",
            ]}
            openedViews={["projects"]}
            setFilter={setFilter}
          />
        </div>
      ) : null}
      <div className={styles.section}>
        <FilterMenu
          filter={filter}
          placeholder={t("projectPage.ganttPage.filters.resourcePlaceholder")}
          views={[
            "resources",
            "resourceTags",
            "projectsElementsTags",
            "groups",
          ]}
          openedViews={["resources"]}
          setFilter={setFilter}
        />
      </div>
      <div className={styles.section}>
        <DataTypeFilter
          dataTypes={filter.elementTypes}
          select={(elementTypes) => setFilter({ ...filter, elementTypes })}
        />
      </div>
      <div>
        <button className={styles.resetButton} onClick={reset}>
          {t("projectPage.ganttPage.filters.resetFilter")}
        </button>
      </div>
    </div>
  );
}

export { Filters };
